import * as React from "react";
import { RootState } from "../../reducers/index";
import { useAppSelector } from "../../store/index";
import { selectTotalPrice } from "../../reducers/cart";
import { formatMoney } from "../../../shared/api/formatutil";
import CartDisplayItem from "./cartdisplayitem";

const Cart = () => {
    const { items } = useAppSelector((state: RootState) => state.cart);
    const totalPrice = useAppSelector((state) => selectTotalPrice(state.cart));

    let cartContents: React.JSX.Element;
    if (items.length === 0) {
        cartContents = (
            <div className="cart-message">You have no items in your cart.</div>
        );
    } else {
        const cartList = items.map((cartitem) => (
            <CartDisplayItem cartitem={cartitem} key={cartitem.id} />
        ));
        cartContents = (
            <>
                {cartList}
            </>
        );
    }

    return (
        <div className="register-cart">
            {cartContents}
            <div className="cart-line" />
            <div className="total-caption">
                Total
            </div>
            <div className="total-price">{formatMoney(totalPrice)}</div>
        </div>
    );
};

export default Cart;
